export const VossTierTagType = {
    Merge: 0,
    Align: 1,
    Require: 2,
    Activate: 3
};